import inversorUnknownImage from "../assets/inversor-unknown.svg";
import inversorOnImage from "../assets/inversor-on.svg";
import inversorOffImage from "../assets/inversor-off.svg";
import inversorNotelemetryImage from "../assets/inversor-notelemetry.svg";

type InverterImageProps = {
    type: "on" | "off" | "notelemetry" | "unknown";
    width?: string | number;
    height?: string | number;
}

export function InverterImage({ type, width, height }: InverterImageProps) {
    const getInversorImage = () => {
        switch (type) {
            case "on":
                return {
                    src: inversorOnImage,
                    alt: "inversor ligado"
                }
            case "off":
                return {
                    src: inversorOffImage,
                    alt: "inversor desligado"
                }
            case "notelemetry":
                return {
                    src: inversorNotelemetryImage,
                    alt: "inversor sem telemetria"
                }
            default:
                return {
                    src: inversorUnknownImage,
                    alt: "inversor com status desconhecido"
                }
        }
    }

    const inversorImage = getInversorImage();

    return (
        <img
            width={width}
            height={height}
            src={inversorImage.src}
            // className="rounded"
            alt={inversorImage.alt}
        />
    )
}